import { OperationTypeEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { MatserClubbedLots } from "./lot-clubbing.entity";
// import { Address } from "./address.entity";

@Entity('child_clubbed_lots')
export class ChildClubbedLots {

  @PrimaryGeneratedColumn("increment",{name:'child_lot_id'})
  childLotId:number;
  @Column("varchar",{
    nullable:false,
    name:"lot_number",
    length:100,

    })
    lotNumber:string;
    @Column("varchar",{
        nullable:false,
        length:100,
        name:"sub_lot_number"
        })
    subLotNumber:string;
    @Column("int",{
        nullable:false,
        name:"quantity"
        })
    quantity:number;
    @Column("int",{
        nullable:false,
        name:"boxes"
        })
    opBoxes:number;
  

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      default: "ADMIN",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })

  versionFlag: number;

  
 
  @ManyToOne(type => MatserClubbedLots, masterLot => masterLot.childLotInfo, { nullable: false, })
  @JoinColumn({ name: "master_lot_id" })
  masterLotInfo: MatserClubbedLots;
  
 


}
